import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {kanPartnersService} from "../../../../services/services/partners";
import {Partner} from "../../../../../classes/partner";
import {StateService} from "@uirouter/angular";
// import {kanPartnerDialog} from "../../../dialogs/partner-dialog/component";
import {MatDialog} from "@angular/material";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {kanPartnerDialog} from "../../../dialogs/partner-dialog/component";
import {Note} from "../../../../../classes/note";
import {kanNoteDialog} from "../../../dialogs/note-dialog/component";
import {kanNotesService} from "../../../../services/services/notes";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-notes-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanNotesListItem {
    @Input() note: Note;
    @Input() searchText: string;
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private notesService: kanNotesService) {
    }

    ngOnInit(): void {
    }

    get role(): string {
        return this.authService.role;
    }

    public edit(event) {
        let dialogRef = this.dialog.open(kanNoteDialog, {
            data: {
                user: this.note.user,
                dog: this.note.dog,
                note: this.note
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'update') {
                    this.refresh.emit();
                }
            });
    }

    public resolve(event) {
        this.note.resolved = true;
        this.note.end = new Date();
        this.notesService.updateNote(this.note)
            .then(() => {
                this.refresh.emit();
            });
    }

    public remove(event) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'remove') {
                    this.notesService.removeNote(this.note)
                        .then((data) => {
                            this.refresh.emit();
                        });
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/notes/list-item/component.ts